import { render, staticRenderFns } from "./server.vue?vue&type=template&id=2614558a&"
import script from "./server.vue?vue&type=script&lang=js&"
export * from "./server.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/www/game/xcp-vue-xcll/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2614558a')) {
      api.createRecord('2614558a', component.options)
    } else {
      api.reload('2614558a', component.options)
    }
    module.hot.accept("./server.vue?vue&type=template&id=2614558a&", function () {
      api.rerender('2614558a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/formSys/server.vue"
export default component.exports